import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=2d6218cc&scoped=true&lang=pug&"
var script = {}
import style0 from "./Productos.vue?vue&type=style&index=0&id=2d6218cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6218cc",
  null
  
)

export default component.exports